import { render, staticRenderFns } from "./ScrollList.vue?vue&type=template&id=30ec3646&scoped=true&"
import script from "./ScrollList.vue?vue&type=script&lang=js&"
export * from "./ScrollList.vue?vue&type=script&lang=js&"
import style0 from "./ScrollList.vue?vue&type=style&index=0&id=30ec3646&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ec3646",
  null
  
)

export default component.exports